module.exports = __webpack_public_path__ + "static/Graphik-Light-Cy-Web-2218f3f8574df373933ffc1ad6540137.woff2";